import Vue from 'vue';
import Vuex from 'vuex';

// import menu from './modules/menu';
// import user from './modules/user';
// import city from './modules/city';
// import global from './modules/global';

// 自动引入modules下的文件
const files = require.context('./modules', false, /\.js$/);
const storeModules = {};
files.keys().forEach(key => {
  // 获取文件名
  const moduleName = key.substr(key.lastIndexOf('/') + 1, key.lastIndexOf('.') - 2);
  storeModules[moduleName] = files(key).default;
});
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // // 用于是否刷新页面
    // appKey:1
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ...storeModules,
    // menu,
    // user,
    // city,
    // global,
  },
});
